/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const getPageTypeDisplayName = (pageType: string = ''): string => {
  if (pageType.includes('product-detail')) {
    return 'PDP';
  } else if (pageType.includes('catalog_shelf')) {
    return 'Shelf';
  } else if (pageType.includes('search_results_shelf')) {
    return 'Search';
  } else if (pageType.includes('home')) {
    return 'Home';
  } else if (pageType.includes('cart')) {
    return 'Cart';
  }

  return pageType;
};
